import {DataStore} from "./DataStore";
import {BaseServiceAbstract} from "./BaseServiceAbstract";

export class BaseService extends BaseServiceAbstract {

    dataStore?: DataStore;
    isCurrentlyLoggedIn?: boolean = null;

    apiHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '',
    };

    constructor(dataStore?: DataStore) {
        super(dataStore);
    }

    getAuthHeader() {
        let headers = super.getAuthHeader() as any;

        if (this.dataStore.retrieveData('user')) {
            headers.Authorization = this.dataStore.retrieveData('user').key;
        }

        return headers;
    }
}
